import { AppSettings } from '@opanuj/shared/types';
import { ref } from 'firebase/database';
import { useDatabase } from './useDatabase';
import { useObjectVal } from 'react-firebase-hooks/database';
import { withDefaultObject } from './defaults';

export const useSettings = () => {
	const database = useDatabase();
	const [settings, loading, error] = useObjectVal<AppSettings>(ref(database, 'settings'));
	return [withDefaultObject(settings), loading, error] as const;
};
